// Module
var code = `<customer-breadcrumbs></customer-breadcrumbs>
<customer-profile-header></customer-profile-header>
<section class="box">
  <sub-header header="'Transfer loan to ROPA'"></sub-header>

  <form-section>

    <form name="ropaForm">
      <table class="table table--generate-row-ids">
        <tbody>
        <tr>
          <td></td>
          <td>Product number:</td>
          <td>
            <input type="text"
                   disabled
                   ng-model="\$ctrl.loan.productNumber"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Product type:</td>
          <td>
            <input type="text"
                   disabled
                   ng-model="\$ctrl.loan.loanType.productDefinition.productName"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Date granted:</td>
          <td>
            <date ng-model="\$ctrl.loan.grantDate"
                  output-format="date"
                  ng-disabled="true"></date>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Maturity date:</td>
          <td>
            <date ng-model="\$ctrl.loan.maturityDate"
                  output-format="date"
                  ng-disabled="true"></date>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Product status:</td>
          <td>
            <input type="text"
                   disabled
                   ng-model="\$ctrl.loan.status"/>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Outstanding balance:</td>
          <td>
            <cash ng-model="\$ctrl.loan.principalBalance"
                  ng-disabled="true">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>AIR balance:</td>
          <td>
            <cash ng-model="\$ctrl.loan.accruedInterest"
                  ng-disabled="true">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>ROPA Land:</td>
          <td>
            <cash ng-model="\$ctrl.request.landAmount"
                  ng-change="\$ctrl.onRopaAmountChanged()"
                  ng-required="true">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>ROPA Building:</td>
          <td>
            <cash ng-model="\$ctrl.request.buildingAmount"
                  ng-change="\$ctrl.onRopaAmountChanged()"
                  ng-required="true">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>ROPA Others:</td>
          <td>
            <cash ng-model="\$ctrl.request.othersAmount"
                  ng-change="\$ctrl.onRopaAmountChanged()"
                  ng-required="true">
            </cash>
          </td>
        </tr>
        <tr>
          <td></td>
          <td>Total ROPA:</td>
          <td>
            <cash ng-model="\$ctrl.totalRopaAmount"
                  min="\$ctrl.loan.principalBalance"
                  max="\$ctrl.loan.principalBalance"
                  ng-disabled="true"
                  ng-required="true">
            </cash>
            <help title="Sum of ROPA Building, Land and Others should be equal to Outstanding Balance"></help>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="flex-end actions">
        <button type="button"
                class="btn btn-warning"
                ng-click="\$ctrl.cancel()">
          Cancel
        </button>
        <button type="button"
                class="btn btn-success"
                ng-disabled="ropaForm.\$invalid"
                ng-click="\$ctrl.transferToRopa()">
          Transfer
        </button>
      </div>

    </form>

  </form-section>

</section>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/ropa/loan-ropa-transfer.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;